import React from 'react';
import {Link} from '@sail/ui';
import {deprecatedCss, view} from '@sail/engine';

const basic = {
  rendered: (
    <view.div uses={[deprecatedCss`layout: row; gap: $spacing-xl;`]}>
      <Link href="https://www.stripe.com">Primary link</Link>&nbsp;
      <Link type="secondary" href="https://www.stripe.com">
        Secondary link
      </Link>
    </view.div>
  ),
  source: `<Link href="https://www.stripe.com">Primary link</Link>
<Link type="secondary" href="https://www.stripe.com">Secondary link</Link>`,
};
const primary = {
  rendered: <Link href="https://www.stripe.com">Primary link</Link>,
  source: `<Link href="https://www.stripe.com">Primary link</Link>`,
};
const secondary = {
  rendered: (
    <Link type="secondary" href="https://www.stripe.com">
      Secondary link
    </Link>
  ),
  source: `<Link type="secondary" href="https://www.stripe.com">Secondary link</Link>`,
};
const disabled = {
  rendered: (
    <view.div uses={[deprecatedCss`layout: row; gap: $spacing-xl;`]}>
      <Link disabled href="https://stripe.com">
        Primary link
      </Link>
      &nbsp;
      <Link type="secondary" disabled href="https://stripe.com">
        Secondary link
      </Link>
    </view.div>
  ),
  source: `<Link disabled href="https://www.stripe.com">Primary link</Link>
<Link type="secondary" href="https://www.stripe.com" disabled>Secondary link</Link>`,
};
const newTab = {
  rendered: (
    <Link href="https://stripe.com" target="_blank" rel="noopener noreferrer">
      Open link in new tab
    </Link>
  ),
  source: `<Link href="https://stripe.com" target="_blank" rel="noopener noreferrer">
  Open link in new tab
</Link>`,
};
export const LinkExamples = {
  basic,
  primary,
  secondary,
  disabled,
  newTab,
};
